import { useHomeUrl, type ITextComponentWithAssetsModel } from "@nf/common";
import { useInView } from "react-intersection-observer";
import { useTranslation } from "next-i18next";
import cx from "classnames";

import Button from "components/Button";
import LandingPageCoverGroup from "../LandingPageCoverGroup";

import type { ILandingPageMovieSelectionComponent } from "../types";

import styles from "./LandingPageMovieSelection.module.scss";

interface LandingPageMovieSelectionProps {
  component: ITextComponentWithAssetsModel;
}

const LEFT_COUNT = 5;
const RIGHT_COUNT = 6;

const LandingPageMovieSelection = ({
  component,
}: LandingPageMovieSelectionProps) => {
  const { t } = useTranslation("translations");
  const { ref, inView } = useInView({ threshold: 0.8, triggerOnce: true });
  const homeUrl = useHomeUrl();

  const { information } =
    component.TextParsed as unknown as ILandingPageMovieSelectionComponent;

  const leftAssets = component.MediaList?.slice(0, LEFT_COUNT);
  const rightAssets = component.MediaList?.slice(
    LEFT_COUNT,
    LEFT_COUNT + RIGHT_COUNT
  );

  return (
    <div
      ref={ref}
      className={cx(styles.container, { [styles.inView]: inView })}
    >
      {leftAssets && (
        <LandingPageCoverGroup
          assets={leftAssets}
          className={styles.left}
          visible={inView}
        />
      )}

      <div className={styles.content}>
        <h1 className={styles.text}>{t("web_landing_page_about_text")}</h1>

        <Button href={homeUrl}>{t("web_start_browse_button")}</Button>

        <div className={styles.cards}>
          {information.map((info, index) => (
            <div
              key={index}
              className={styles.card}
              style={{ transitionDelay: `${index * 0.15}s` }}
            >
              <span className={styles.icon}>
                <img alt="" src={info.icon} />
              </span>
              <div className={styles.title}>{info.title}</div>
              <div className={styles.subtitle}>{info.subtitle}</div>
            </div>
          ))}
        </div>
      </div>

      {rightAssets && (
        <LandingPageCoverGroup
          assets={rightAssets}
          className={styles.right}
          startIndex={LEFT_COUNT}
          visible={inView}
        />
      )}
    </div>
  );
};

export default LandingPageMovieSelection;
